import { IconType } from "../icons";
import { ProductType } from "../hooks/products/interfaces";

export const productIconMap: Record<ProductType, IconType> = {
  [ProductType.ALBUMS]: IconType.CardsStar,
  [ProductType.COLLECTIONS]: IconType.Stacks,
  [ProductType.SHELVINGS]: IconType.Shelves,
  [ProductType.ARTISTS]: IconType.Artist,
  [ProductType.LABELS]: IconType.MusicCast,
  [ProductType.ALBUM_FORMATS]: IconType.ControlCamera,
  [ProductType.ALBUM_TYPES]: IconType.Album,
  [ProductType.STORES]: IconType.Store,
  [ProductType.SELL_VALUES]: IconType.PriceChange,
  [ProductType.EXCHANGE_RATES]: IconType.CurrencyExchange,
  [ProductType.TAGS]: IconType.Sell,
  [ProductType.LISTENING_SESSIONS]: IconType.Headphones,
  [ProductType.BUNDLES]: IconType.LocalMall
};
